import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vitaldev.vitalinsights.in/admin';
const APPOINTMENT_API_URL = 'https://vitaldev.vitalinsights.in';

const getAuthToken = () => localStorage.getItem('token');

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

const appointmentApiClient = axios.create({
  baseURL: APPOINTMENT_API_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

appointmentApiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const appointmentService = {
  getUnpaidAppointments: async (fromDate, toDate, branchId = null) => {
    try {
      let url = `/appointments?from_date=${fromDate}&to_date=${toDate}`;
      
      // For admin users, always include their branch_id
      const userRole = localStorage.getItem('user_role');
      const storedBranchId = localStorage.getItem('branch_id');
      
      if (userRole === 'admin' && storedBranchId) {
        url += `&branch_id=${storedBranchId}`;
      } else if (branchId) {
        url += `&branch_id=${branchId}`;
      }
      
      const response = await apiClient.get(url);
      
      // Handle both array and object responses
      let appointments = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      
      // Filter for unpaid appointments only
      const unpaidAppointments = appointments.filter(appointment => 
        !appointment.payment_id || 
        appointment.payment_id.trim() === '' || 
        appointment.payment_id === null || 
        appointment.payment_id === undefined
      );
      
      return unpaidAppointments;
    } catch (error) {
      console.error('Error fetching unpaid appointments:', error);
      throw error;
    }
  },

  getAllAppointments: async (fromDate, toDate, branchId = null) => {
    try {
      let url = `/appointments?from_date=${fromDate}&to_date=${toDate}`;
      
      // For admin users, always include their branch_id
      const userRole = localStorage.getItem('user_role');
      const storedBranchId = localStorage.getItem('branch_id');
      
      if (userRole === 'admin' && storedBranchId) {
        url += `&branch_id=${storedBranchId}`;
      } else if (branchId) {
        url += `&branch_id=${branchId}`;
      }
      
      const response = await apiClient.get(url);
      
      // Handle both array and object responses
      return Array.isArray(response.data) ? response.data : (response.data?.data || []);
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },

  getSlots: async (date, collectionType, testIds, facilityId = null, addressId = null) => {
    try {
      const params = {
        date,
        collection_type: collectionType,
        test_ids: testIds.join(','),
      };

      if (collectionType === 'centre' && facilityId) {
        params.facility_id = facilityId;
      } else if (collectionType === 'home' && addressId) {
        params.address_id = addressId;
      }

      const response = await appointmentApiClient.get('/appointment/slots', { params });
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching slots:', error);
      throw error;
    }
  },

  rescheduleAppointment: async (appointmentId, selectedDate, selectedSlot) => {
    try {
      const response = await appointmentApiClient.post(`/appointment/reschedule/${appointmentId}`, {
        date: selectedDate,
        slot: selectedSlot,
      });
      return response.data;
    } catch (error) {
      console.error('Error rescheduling appointment:', error);
      throw error;
    }
  },
};
